import {
    ServiceSettingsCalendarSlotDuration,
    ServiceSettingsCalendarTimeFormat,
} from '@libs/types/src/services/enum/service-settings-calendar.enum';

export type CommonServiceSettingsType = {
    useCard: boolean,
    customCardName: string | null,
    shareWithOtherServices: number[],
}

export const COMMON_SERVICE_SETTINGS_DEFAULT: CommonServiceSettingsType = {
    useCard: true,
    customCardName: null,
    shareWithOtherServices: [],
};

export interface SocialServiceSettingsPaymentType extends CommonServiceSettingsType {
    dueDays: number;
    useDownPayment: boolean;
}

export interface ServiceSettingsCalendarType extends CommonServiceSettingsType {
    calendarTypes: string[];
    firstDayOfWeek: number;
    workWeek: number[];
    dayStartHour: number;
    dayEndHour: number;
    workStartHour: number;
    workEndHour: number;
    slotDuration: ServiceSettingsCalendarSlotDuration;
    slotInterval: number;
    timeFormat: ServiceSettingsCalendarTimeFormat;
    weekNumbers: boolean;
}

export const SERVICE_SETTINGS_CONTACTS_TYPE_KEY = 'service_settings_contacts_type';

export const SERVICE_SETTINGS_DASHBOARD_TYPE_KEY = 'service_settings_dashboard_type';

export type ServiceSettingsDashboardAnamnesisFieldsType = {
    anamnesis: boolean;
    socialAnamnesis: boolean;
    nurseRecommendations: boolean;
    statusPraesens: boolean;
};

export type ServiceSettingsDashboardType = Partial<CommonServiceSettingsType> & {
    [key: string]: unknown;
    anamnesis?: boolean;
    anamnesisFields?: Partial<ServiceSettingsDashboardAnamnesisFieldsType>;
};

export const SERVICE_SETTINGS_DASHBOARD_ANAMNESIS_FIELDS_DEFAULT: ServiceSettingsDashboardAnamnesisFieldsType = {
    anamnesis: true,
    socialAnamnesis: true,
    nurseRecommendations: true,
    statusPraesens: true,
};

export const SERVICE_SETTINGS_DASHBOARD_DEFAULT: ServiceSettingsDashboardType = {
    ...COMMON_SERVICE_SETTINGS_DEFAULT,
    anamnesis: true,
    anamnesisFields: SERVICE_SETTINGS_DASHBOARD_ANAMNESIS_FIELDS_DEFAULT,
};

export const SERVICE_SETTINGS_CARE_PLAN_TYPE_KEY = 'service_settings_care_plan_type';

export const SERVICE_SETTINGS_CALENDAR_TYPE_KEY = 'service_settings_calendar_type';
export const SERVICE_SETTINGS_CALENDAR_DEFAULT: ServiceSettingsCalendarType = {
    ...COMMON_SERVICE_SETTINGS_DEFAULT,
    calendarTypes: [],
    firstDayOfWeek: 1,
    workWeek: [1, 2, 3, 4, 5],
    dayStartHour: 0,
    dayEndHour: 24,
    workStartHour: 8,
    workEndHour: 16,
    slotDuration: ServiceSettingsCalendarSlotDuration.HOUR,
    slotInterval: 1,
    timeFormat: ServiceSettingsCalendarTimeFormat.HOURS_24,
    weekNumbers: true,
};

export const SERVICE_SETTINGS_EPICRISIS_TYPE_KEY = 'service_settings_epicrisis_type';

export const SERVICE_SETTINGS_SPECIALIST_RECORD_TYPE_KEY = 'service_settings_specialist_record_type';

export const SERVICE_SETTINGS_SCHEDULER_TYPE_KEY = 'service_settings_scheduler_type';

export const SERVICE_SETTINGS_NURSE_RECORD_TYPE_KEY = 'service_settings_nurse_record';

export const SERVICE_SETTINGS_CONTINUOUS_RECORD_TYPE_KEY = 'service_settings_continuous_record';

export const SERVICE_SETTINGS_MOVEMENT_RESTRICTION_TYPE_KEY = 'service_settings_movement_restriction';

export const SERVICE_SETTINGS_INDIVIDUAL_PLAN_TYPE_KEY = 'service_settings_individual_plan';

export const SERVICE_SETTINGS_SANCTION_TYPE_KEY = 'service_settings_sanction';

export const SERVICE_SETTINGS_SUGGESTION_TYPE_KEY = 'service_settings_suggestion';

export const SERVICE_SETTINGS_MAIL_TYPE_KEY = 'service_settings_mail';

export const SERVICE_SETTINGS_WAREHOUSE_MATERIAL_TYPE_KEY = 'service_settings_warehouse_material';

export const SERVICE_SETTINGS_SERVICE_ANNOUNCEMENT_TYPE_KEY = 'service_settings_service_announcement';

export const SERVICE_SETTINGS_TASKS_TYPE_KEY = 'service_settings_tasks';

export const SERVICE_SETTINGS_DIET_TYPE_KEY = 'service_settings_diet';
export const SERVICE_SETTINGS_SOCIAL_WORK_KEY = 'social_service_work';

export const SERVICE_SETTINGS_BASIC_SOCIAL_CONSULTING_KEY = 'service_settings_basic_social_consulting';

export const SERVICE_SETTINGS_PROVIDED_OPERATIONS_REPORTS_KEY = 'service_settings_provided_operations_reports';

export const SERVICE_SETTINGS_ATTENDANCE_TYPE_KEY = 'service_settings_attendance';
export const SERVICE_SETTINGS_ATTENDANCE_DEFAULT: CommonServiceSettingsType = {
    ...COMMON_SERVICE_SETTINGS_DEFAULT,
};

export const SERVICE_SETTINGS_TANGIBLE_DEPOSITS_TYPE_KEY = 'service_settings_tangible_deposits';

export const SOCIAL_SERVICE_SETTINGS_PAYMENT_TYPE_KEY = 'social_service_settings_payment_type_key';

export const SOCIAL_SERVICE_SETTINGS_BILLING_TYPE_KEY = 'social_service_settings_billing_type_key';

export const SOCIAL_SERVICE_SETTINGS_FINANCIAL_DEPOSIT_TYPE_KEY = 'social_service_settings_financial_deposit_type_key';

export const SERVICE_SETTINGS_EPOUKAZ_TYPE_KEY = 'service_settings_epoukaz_type';

export const SERVICE_SETTINGS_NURSING_ALLOWANCE_TYPE_KEY = 'service_settings_care_notes_type';
